export interface IStatusModel {
    code: string;
    name: string;
}

export class StatusModel implements IStatusModel {
    code: string;
    name: string;

    constructor(data: IStatusModel) {
        this.code = data.code;
        this.name = data.name;
    }
}